import { render, staticRenderFns } from "./PackageListCard.vue?vue&type=template&id=6f346aee&scoped=true"
import script from "./PackageListCard.vue?vue&type=script&lang=js"
export * from "./PackageListCard.vue?vue&type=script&lang=js"
import style0 from "./PackageListCard.vue?vue&type=style&index=0&id=6f346aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f346aee",
  null
  
)

export default component.exports